import PropTypes from "prop-types";
import Button from "components/ui/button/index.jsx";
import { mergeClassNames } from "utils/common.js";

const GradientButton = ({ type = "primary", children, className, icon, ...buttonProps }) => {
	return (
		<>
			<Button className={mergeClassNames("vs--ui-gradient-button", className, type, icon ? 'with-icon' : '')} type={"button"} {...buttonProps} icon={icon}>
				<span className="vs--ui-gradient-button-text">{children}</span>
			</Button>
		</>
	);
};

GradientButton.propTypes = {
	children: PropTypes.node,
	type: PropTypes.string,
	className: PropTypes.string,
	icon: PropTypes.node
};

export default GradientButton;
